const PER_PAGE_DEFAULT = 10;

const getPageFromUrl = (): number => {
  const page = Number(new URLSearchParams(window.location.search).get("page"));
  return Number.isInteger(page) && page > 0 ? page : 1;
};

export const peoplePager = (): void => {
  const list = document.querySelector<HTMLElement>("[data-people-list]");
  if (!list) return;

  const items = Array.from(list.querySelectorAll<HTMLElement>(".p-people-list__item"));
  const links = Array.from(document.querySelectorAll<HTMLAnchorElement>("[data-people-page]"));
  const perPage = Number(list.dataset.perPage) || PER_PAGE_DEFAULT;
  const totalPages = Math.max(1, Math.ceil(items.length / perPage));

  const scrollToList = (): void => {
    const header = document.querySelector<HTMLElement>(".l-header__top");
    const headerHeight = header?.getBoundingClientRect().height ?? 0;
    const top = window.scrollY + list.getBoundingClientRect().top - headerHeight - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  };

  const showPage = (page: number, shouldScroll = false): void => {
    const current = Math.min(Math.max(page, 1), totalPages);
    const start = (current - 1) * perPage;
    const end = start + perPage;

    items.forEach((item, index) => {
      item.hidden = index < start || index >= end;
    });

    links.forEach((link) => {
      const isCurrent = Number(link.dataset.peoplePage) === current;
      link.classList.toggle("is-current", isCurrent);
      if (isCurrent) {
        link.setAttribute("aria-current", "page");
      } else {
        link.removeAttribute("aria-current");
      }
    });

    if (shouldScroll) {
      scrollToList();
    }
  };

  links.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const page = Number(link.dataset.peoplePage);
      const url = new URL(window.location.href);
      url.searchParams.set("page", String(page));
      history.pushState({ page }, "", url);
      showPage(page, true);
    });
  });

  window.addEventListener("popstate", () => {
    showPage(getPageFromUrl(), true);
  });

  showPage(getPageFromUrl());
};
